export const Breadcrumb = {
  baseStyle: {
    link: {
      _hover: {
        textDecoration: "inherit",
      },
    },
  },
}
